/**
 * API Configuration for StockPro
 */

const environment = process.env.NODE_ENV || 'development';

const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:8787/api', // Cloudflare Workers dev server default port
    timeout: 10000,
    withCredentials: false
  },
  production: {
    baseURL: '/api', // When deployed to Cloudflare, the API is at /api
    timeout: 10000,
    withCredentials: false
  },
  test: {
    baseURL: '/api',
    timeout: 10000,
    withCredentials: false
  }
};

export default API_CONFIG[environment];